__turbopack_context__.v({
  "accordionContainer": "SellInMarketplaceLinkAccordion-module-scss-module__32XZPq__accordionContainer",
});
